<template>
  <div class="joinUs-page">
    <img src="https://img.loklok.video/fe/0e3ecf40-8312-4d09-a155-15f7904a8ab4/contact-cover.png" alt="loklok app screenshot" class="cover" />
    <h1 v-t="'navigator.joinUs'"></h1>
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane name="phi">
        <span slot="label">
          <img src="https://img.loklok.video/fe/54fb1369-a817-4b48-81d9-f41a59671561/joinUs_vietnam.png" alt="" />
          <span>Vietnam</span>
        </span>
        <p>Tuyển dụng làm việc tự do:</p>
        <p>Bạn muốn kiếm thêm thu nhập?</p>
        <p>Hãy tham gia với chúng tôi để kiếm lên đến 3.503.250 đồng mỗi tháng!</p>
        <p>Liên hệ với chúng tôi để biết thêm về điều khoản và điều kiện.</p>
        <br />
        <p>Đường link đăng ký:</p>
        <a href="https://forms.gle/BPEAfMi638Wh5Qvo7" target="_block">https://forms.gle/BPEAfMi638Wh5Qvo7</a>
      </el-tab-pane>
      <el-tab-pane name="in_ID">
        <span slot="label">
          <img src="https://img.loklok.video/fe/e278f33f-039c-476e-9d67-06c5936d3801/joinUs_indonesia.png" alt="" />
          <span>Indonesia</span>
        </span>
        <p>工作时间：14:00-23:00，远程办公</p>
        <br />
        <p>直播房间管理员（印尼/马来/菲律宾）</p>
        <p>岗位职责</p>
        <p>1、负责督促主播开播，每日巡查直播间内容，记录主播违规事项并跟进处罚、整改；</p>
        <p>2、挖掘玩法，优化直播内容，提升用户体验；</p>
        <p>3、跟踪主播直播效果，输出优化方案。</p>
        <br />
        <p>任职要求：</p>
        <p>1、会中文和英语优先</p>
        <p>2、有数据敏感度，能够及时发现异常数据，并同步团队一起解决</p>
        <br />
        <p>简历可投递邮箱：baijingjing@loklok.com</p>
        <br />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'joinUs',
  data() {
    return {
      activeName: 'phi'
    }
  },
  mounted() {
    this.activeName = this.$i18n.localeProperties.code == 'in_ID' ? 'in_ID' : 'phi'
  },
  methods: {}
}
</script>
<style scoped lang="sass">
.joinUs-page
  @include border-box
  align-items: left
  max-width: 1240px
  margin: 0 auto
  user-select: none
  padding-top: 20px
  padding-left: 20px
  padding-right: 20px
  display: flex
  flex-direction: column
  align-items: self-start
  .cover
    flex-shrink: 1
    width: 100%
    margin-bottom: 4px
    object-fit: contain
  h1
    font-style: normal
    font-weight: 700
    font-size: 24px
    line-height: 150%
    color: #F5F5F5
    margin: 20px 0
  :deep
    .el-tabs
      width: 100%
    .el-tabs,.el-tabs__header
      background: transparent
      border: 0
      height: 47px
    .el-tabs__content
      background: #444444
      min-height: 250px
      border-radius: 0 8px 8px 8px
      p
        font-style: normal
        font-weight: 700
        font-size: 14px
        line-height: 200%
        color: #999999
      a
        color: #995AFF
    .el-tabs__item
      background: #333333
      color: #F5F5F5
      border: 0
      height: 47px
      margin: 0
      &:first-child
        border-top-left-radius: 8px
      &:last-child
        border-top-right-radius: 8px
      &:hover
        color: #995AFF !important
      img
        width: 24px
        height: 12px
        margin-right: 10px
        vertical-align: middle
        &+span
          vertical-align: middle
    .el-tabs__item.is-active
      background: #444444
      color: #F5F5F5
@media screen and (max-width: 960px)
  .joinUs-page
    padding-left: 40px
    padding-right: 40px
    // .cover
    //   display: none
@media screen and (max-width: 750px)
  .joinUs-page
    padding-left: 20px
    padding-right: 20px
    justify-content: center
    // .cover
    //   display: none
    // .center-wrap
    //   display: none
</style>
